import { render } from "./NewContentToLessonsCardForLive.vue?vue&type=template&id=568aa4f0&scoped=true"
import script from "./NewContentToLessonsCardForLive.vue?vue&type=script&lang=js"
export * from "./NewContentToLessonsCardForLive.vue?vue&type=script&lang=js"

import "./NewContentToLessonsCardForLive.vue?vue&type=style&index=0&id=568aa4f0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568aa4f0"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
